const timestamp = Date.now().toString();

export default {
  highlightPreTag: `<ais-highlight-${timestamp}>`,
  highlightPostTag: `</ais-highlight-${timestamp}>`,
};



// WEBPACK FOOTER //
// ./src/core/highlightTags.js